import store from '../../store';
import { addLineItems } from '../../slices/cart';

window.readOnlyPurpleStore = store;

window.sharedThunks = { addLineItems };
